import React from 'react'

const Others = () => (
  <div>
    <div className="row width-container center-image">
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/bSB6HvPzOqo"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/UyObNjQhwVs"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/5aIVsCVBgrw"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/afrVrKi4-kw"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/7h0Qc4rhgAA"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/xQ1LZBaMo98"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/3CDjX68uPFI"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/G8n-YLmXqGY"
          allowFullScreen
        ></iframe>
      </div>
      <div className="embed-responsive video embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="https://www.youtube.com/embed/eQh2wH03y6I"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  </div>
)

export default Others



// WEBPACK FOOTER //
// ./src/pages/animation/others.js